import cn from 'classnames/bind'
import type { Field } from 'factorial-form'
import _ from 'lodash'

import { observer } from 'mobx-react'

import { useCurrentAccessWeekdays } from 'modules/core/hooks/useCurrentAccessWeekdays'
import i18n from 'modules/core/lib/i18n'

import styles from './index.module.css'

const getWorkDaysLabel = (type: string) => {
  switch (type) {
    case 'friday':
      return i18n.t('hiring.work_days.friday')
    case 'monday':
      return i18n.t('hiring.work_days.monday')
    case 'saturday':
      return i18n.t('hiring.work_days.saturday')
    case 'sunday':
      return i18n.t('hiring.work_days.sunday')
    case 'thursday':
      return i18n.t('hiring.work_days.thursday')
    case 'tuesday':
      return i18n.t('hiring.work_days.tuesday')
    case 'wednesday':
      return i18n.t('hiring.work_days.wednesday')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

interface Props {
  field: Field
  readonly?: boolean
  canUnselectAll?: boolean
  fullWidth?: boolean
}

const cx = cn.bind(styles)

const DaysSelector = ({ field, readonly, canUnselectAll, fullWidth }: Props) => {
  const weekDays = useCurrentAccessWeekdays()

  const select = (day: string) => {
    if (readonly) return

    const selectedDays: string[] = field.value ? field.value.split(',') : []
    const index = selectedDays.findIndex((d) => d === day)

    if (index > -1) {
      if (!canUnselectAll && selectedDays.length === 1) return

      selectedDays.splice(index, 1)

      if (!selectedDays.length) {
        field.set('')

        return
      }

      field.set(selectedDays.join(','))

      return
    }

    field.set(selectedDays.concat([day]).join(','))
  }

  const selectedDays = field.value.split(',')

  return (
    <div className={styles.root}>
      {weekDays.map((day) => {
        const shortDay = getWorkDaysLabel(day ?? '')

        return (
          <div
            className={cx('day', {
              selected: _.includes(selectedDays, day),
              readonly,
              fullwidth: fullWidth,
            })}
            onClick={() => select(day)}
            key={day}
          >
            {shortDay}
          </div>
        )
      })}
    </div>
  )
}

export default observer(DaysSelector)
